import { defineComponent as _defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { useMeta } from 'vue-meta'


export default /*#__PURE__*/_defineComponent({
  __name: 'AffirmCancelled',
  setup(__props, { expose }) {
  expose();

useMeta({ title: 'Payment cancelled' })
const route = useRoute()

const __returned__ = { route, useRoute, useMeta }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})